/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateTenantWithNewRealmInput = {
    realm: RealmInput;
    tenant: TenantInput;
};
export type RealmInput = {
    clusterId: string;
    name: string;
};
export type TenantInput = {
    frontendDomain: string;
    name: string;
    slug: string;
};
export type TenantCreate_createTenant_MutationVariables = {
    input: CreateTenantWithNewRealmInput;
};
export type TenantCreate_createTenant_MutationResponse = {
    readonly createTenantWithNewRealm: {
        readonly tenant: {
            readonly id: string;
        };
    } | null;
};
export type TenantCreate_createTenant_Mutation = {
    readonly response: TenantCreate_createTenant_MutationResponse;
    readonly variables: TenantCreate_createTenant_MutationVariables;
};



/*
mutation TenantCreate_createTenant_Mutation(
  $input: CreateTenantWithNewRealmInput!
) {
  createTenantWithNewRealm(input: $input) {
    tenant {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTenantWithNewRealmPayload",
    "kind": "LinkedField",
    "name": "createTenantWithNewRealm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tenant",
        "kind": "LinkedField",
        "name": "tenant",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TenantCreate_createTenant_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TenantCreate_createTenant_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d107e76249e16ec837e55483704e16cb",
    "id": null,
    "metadata": {},
    "name": "TenantCreate_createTenant_Mutation",
    "operationKind": "mutation",
    "text": "mutation TenantCreate_createTenant_Mutation(\n  $input: CreateTenantWithNewRealmInput!\n) {\n  createTenantWithNewRealm(input: $input) {\n    tenant {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '4aeb4f04f6f5569b52443a4db5446535';
export default node;
